import React, { useState } from "react";
import closeBtn from "../../assets/svg/free-icon-minimize-sign-6057365 2.svg";

const ChangePasswordForm = ({ changeIsDataFormOpen }) => {
  const [family, setFamily] = useState("");
  const [name, setName] = useState("");
  const [surname, setSurame] = useState("");
  const [dative, setDative] = useState("");
  const [genitive, setGenitive] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [birthDate, setBirthDate] = useState("");
  const [gender, setGender] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [type, setType] = useState("");
  const [timeZone, setTimeZone] = useState("");
  const [city, setCity] = useState("");

  const handleSubmit = (e) => {};

  return (
    <div className="overlay">
      <div className="form-container personalData">
        {/* Editable from here */}
        <h2 className="header">Личные данные</h2>
        <form onSubmit={handleSubmit}>
          {/* --- row1 --- */}
          <div className="row">
            <div className="form-group">
              <label className="label">Фамилия</label>
              <input
                type="text"
                placeholder="Иванов"
                value={family}
                onChange={(e) => setFamily(e.target.value)}
                className="input"
              />
            </div>
            <div className="form-group">
              <label className="label">Имя</label>
              <input
                type="text"
                placeholder="Иван"
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="input"
              />
            </div>
            <div className="form-group">
              <label className="label">Отчество</label>
              <input
                type="text"
                placeholder="Иванович"
                value={surname}
                onChange={(e) => setSurame(e.target.value)}
                className="input"
              />
            </div>
          </div>
          {/* --- row 2 --- */}
          <div className="row">
            <div className="form-group">
              <label className="label">Дательный падеж</label>
              <input
                type="text"
                placeholder="Иванову"
                value={dative}
                onChange={(e) => setDative(e.target.value)}
                className="input"
              />
            </div>
            <div className="form-group">
              <label className="label">Родительный падеж</label>
              <input
                type="text"
                placeholder="Иванова"
                value={genitive}
                onChange={(e) => setGenitive(e.target.value)}
                className="input"
              />
            </div>
          </div>
          {/* --- row3 --- */}
          <div className="row">
            <div className="form-group">
              <label className="label">Пароль</label>
              <input
                type="password"
                placeholder="1234567890"
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                className="input"
              />
            </div>
          </div>
          {/* --- row4 --- */}
          <div className="row">
            <div className="form-group">
              <label className="label">Дата рождения</label>
              <input
                type="date"
                placeholder="__.__.____"
                value={birthDate}
                onChange={(e) => setBirthDate(e.target.value)}
                className="input"
              />
            </div>
            <div className="form-group">
              <label className="label">Пол</label>
              <input
                type="text"
                placeholder="Мужской"
                value={gender}
                onChange={(e) => setGender(e.target.value)}
                className="input"
              />
            </div>
          </div>
          {/* --- row5 --- */}
          <div className="row">
            <div className="form-group">
              <label className="label">Телефон</label>
              <input
                type="phone"
                placeholder="+7 (999) 999-99-99"
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
                className="input"
              />
            </div>
            <div className="form-group">
              <label className="label">Почта</label>
              <input
                type="email"
                placeholder="Example@mail.ru"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="input"
              />
            </div>
          </div>
          {/* --- row6 --- */}
          <div className="row">
            <div className="form-group form-group__type">
              <label className="label">Тип сотрудника</label>
              <input
                type="text"
                placeholder="-"
                value={type}
                onChange={(e) => setType(e.target.value)}
                className="input"
              />
            </div>
          </div>
          {/* --- row7 --- */}
          <div className="row">
            <div className="form-group">
              <label className="time">Часовой пояс</label>
              <input
                type="text"
                placeholder="Иванов Иван Иванович"
                value={timeZone}
                onChange={(e) => setTimeZone(e.target.value)}
                className="input"
              />
            </div>
            <div className="form-group">
              <label className="label">Город</label>
              <input
                type="text"
                placeholder="Москва"
                value={city}
                onChange={(e) => setCity(e.target.value)}
                className="input"
              />
            </div>
          </div>
          {/* Editable till here */}
          <button type="submit" className="btn popPasswordBtn">
            Подтвердить
          </button>
        </form>
        <div className="closeForm">
          <button
            className="closePasswordFormBtn"
            onClick={changeIsDataFormOpen}
          >
            <img src={closeBtn} alt="CloseBtn" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordForm;
